<app-button-outline
  [action]="exitAction"
  [isHighlight]="false"
  [typeOfButton]="ButtonOutline[1]"
  [disabled]="!_stateManagerProjectService.isViewerLoaded"
></app-button-outline>
